import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { RootState } from '../../../store';
import { IUserState } from '../../auth/reducers';
import * as Actions from '../actions';
import MyTeamComponent from '../components/MyTeamComponent';
import { ITeam, ITeamMember } from '../reducers';

const mapStateToProps = (state: RootState) => {
  const team: ITeam = state.teamReducer;
  const user: IUserState = state.authReducer.user;
  const refetentials = state.referentialReducer.referentials;
  return {
    team,
    user,
    refetentials
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTeam: () => {
      return new Promise((resolve: any, reject: (response: string) => void) => {
        dispatch(Actions.getTeam(resolve, reject));
      });
    },
    createTeamMember: (teamMember: ITeamMember) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.createTeamMember(teamMember, resolve, reject));
      });
    },
    updateTeamMember: (teamMember: ITeamMember) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.updateTeamMember(teamMember, resolve, reject));
      });
    },
    deleteTeamMember: (teamMember: ITeamMember) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.deleteTeamMember(teamMember, resolve, reject));
      });
    }
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromReduxMyTeam = ConnectedProps<typeof connector>;

export default withRouter(connector(MyTeamComponent));
